
/*
* Hardcoded checkouts list:
* 197 -> SARL
* 124 -> SCI
* 162 -> Association
* 175 -> SAS
* 176 -> SASU
* 181 -> Auto-Entrepreneur
* 198 -> EURL
* 229 -> CSE moins de 20 employés
*/
export const HARCODED_CHECKOUT_META_IDS = [197, 124, 162, 175, 176, 181, 198, 184, 219, 227, 229, 230, 231, 287, 296, 301, 616, 680];

export const CUSTOM_CGV_LINK_PER_META_IDS = {
    229: 'https://www.legalplace.fr/guides/wp-content/uploads/2019/09/CGV-LP-CSE.pdf'
}

// This fees should be deduced from the tracking
export const HARDCODED_FEES_PER_META_IDS = {
    136: 54.42,
}

// used for bing, facebook, google Adwords
export const HARDCODED_CONVERSION_VALUE_META_IDS = {
    2:  16.58, // Bail commercial
    80: 16.58, // Bail précaire
    75: 16.58, // Bail professionnel
    1: 16.58, // Contrat de location vide
    3: 16.58, // Contrat de location meublée
    11: 16.58, // Contrat de location saisonière
}

export const HARCODED_NEW_CALCUL_PRICE_CHECKOUT_META_IDS = [227, 287, 296, 616]


export const HARCODED_STEP_EXPERT_COMPTABLE_CHECKOUT_META_IDS = [175, 176, 197, 198]


// WEBPACK FOOTER //
// ./src/constants/hardcoded_checkout.js